import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
//import { actionCreators } from '../store/WeatherForecasts';
import { actionCreators } from '../store/actions/dataActions';
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Shortlist from './shortlist';
import ListShortlists from './ListShortLists';
import ShortListFromISRC from './ShortListFromISRC';
import "react-table/react-table.css";
import Select from 'react-select';
import ReadyShortlist from './ReadyShortlists';
import { CSVLink } from 'react-csv';
import Territories from './Territories';
import PublishProducts from './PublishProducts';
import CatalogUpdate from './UpdateCatalog';
import MassProductUpdate from './UpdateProductMass';
import DownloadArtworks from './DownloadArtworks';
import UpdateProducts from './UpdateProducts';
import UpdateAssets from './UpdateAssets';
import UpdateLyricist from './UpdateLyricist';
import UpdateLOP from './UpdateLOP';



class Utilities extends Component {

    constructor(props) {
        super(props);
        this.state = {
            filtered: [],
            select2: undefined
        };
     
    }
componentDidMount() {
    // This method is called when the component is first added to the document
   
    this.ensureDataFetched();
   
}

componentDidUpdate() {
    // This method is called when the route parameters change
    //this.ensureDataFetched();
}

ensureDataFetched() {
    const startDateIndex = parseInt(this.props.match.params.startDateIndex, 10) || 0;
    // this.props.requestWeatherForecasts(startDateIndex);
    this.props.getData();
 
    }

    onFilteredChangeCustom = (value, accessor) => {
        let filtered = this.state.filtered;//this.props.filtered;
        let insertNewFilter = 1;

      
        
            if (filtered.length) {
                filtered.forEach((filter, i) => {
                    if (filter["id"] === accessor) {
                        if (value === "" ||  value === null) filtered.splice(i, 1);
                        else filter["value"] = value;
                        insertNewFilter = 0;
                    }
                });
            }

            if (insertNewFilter) {
                filtered.push({ id: accessor, value: value });
            }



      
        //this.props.setCatalogueFilter(filtered);
        this.setState({ filtered: filtered });
    };


render() {
    const access = localStorage.getItem("accessToken");
   
    let url = this.props ? this.props.audioURL : '';
    return (
        <div> <Tabs selectedIndex={this.props.tabIndex} onSelect={tabIndex => this.props.setTab( tabIndex)}>
            <TabList>
              
                <Tab>
                    Create Product from ISRC
        </Tab>
                <Tab>
                    Update Territories
                    </Tab>
                <Tab>
                    Publish Products
                </Tab>
                <Tab>
                    Update Catalog
                </Tab>
                <Tab>
                    Update C&P
                </Tab>
                <Tab>
                    Download Artworks
                </Tab>
                <Tab>
                    Update Products
                </Tab>
                <Tab>
                    Update Assets
                </Tab>
                <Tab>
                    Update LoP
                </Tab>
                <Tab>
                    Update Lyricist    
                </Tab>
               
            </TabList>
         
           
            <TabPanel> <ShortListFromISRC /></TabPanel>
            <TabPanel><Territories /></TabPanel>
            <TabPanel><PublishProducts /></TabPanel>
            <TabPanel><CatalogUpdate /></TabPanel>
            <TabPanel><MassProductUpdate /></TabPanel>
            <TabPanel><DownloadArtworks /></TabPanel>
            <TabPanel><UpdateProducts /></TabPanel>
            <TabPanel><UpdateAssets /></TabPanel>
            <TabPanel><UpdateLOP /></TabPanel>
            <TabPanel><UpdateLyricist /></TabPanel>
        </Tabs>          
            
            
          

        </div>
    );
}
}



function renderReactTable(data, props,main) {

    console.info(main.state.filtered);
    const onRowClick = (state, rowInfo, column, instance) => {
        if (typeof rowInfo !== "undefined") {
            return {
              
                style: {
                    background: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? '#00afec' : 'white',
                    color: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? 'white' : 'black',
                    
                }
            }
        } else {
            return {
                onClick: (e, handleOriginal) => {
                    if (handleOriginal) {
                        handleOriginal()
                    }
                }
            }
        }
    }
    return (
        <ReactTable
            getTrProps={onRowClick}
            data={data}
            filterable
            filtered={main.state.filtered}
            onFilteredChange={(filtered, column, value) => {
                main.onFilteredChangeCustom(value, column.id || column.accessor);
            }}
          
            defaultFilterMethod={(filter, row, column) => {
                const id = filter.pivotId || filter.id;                
                if (typeof filter.value === "object") {                    
                    return row[id] !== undefined || row[id] !==  null
                        ? filter.value.indexOf(row[id]) > -1
                        : true;
                } else {
                    return row[id] !== undefined
                        ? String(row[id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        : true;
                }
            }}

              
            columns={[
                {
                    Header: "Basic Data",
                    columns: [
                        {
                            Header: "ISRC",
                            accessor: "isrc",
                            Cell: row => (
                                <span style={{ cursor: 'pointer' }} onClick={() => props.selectTrack(row.value)}> {props.tempShortList && props.tempShortList.filter(t => t.isrc === row.value).length > 0 ? row.value : row.value}</span>
                            )
                        },
                        {
                            Header: "Audio",
                            accessor: "fugaID",
                            Cell: row => (
                                <button onClick={() => props.setAudioUrl(row.value)}> {props.audioURL === row.value ? "Playing" : "Play"}</button>
                            ),
                            Filter: ({ filter, onChange }) => {
                                return ("")
                            }
                        },
                        {
                            Header: "Title",
                            accessor: "name"
                        },
                        {
                            Header: "Artist",
                            accessor: "displayArtist"
                        },
                        {
                            Header: "Original Artist",
                            accessor: "originalArtist"
                        },
                        {
                            Header: "Version",
                            accessor: "version"
                        },
                        {
                            Header: "Genre",
                            accessor: "genre",
                            Filter: ({ filter, onChange }) => {
                                return ("")
                            }
                        },
                        {
                            Header: "SubGenre",
                            accessor: "subgenre"
                        },
                        {
                            Header: "Catalog",
                            accessor: "catalog",
                            Filter: ({ filter, onChange }) => {
                                return ("")
                            }
                        },                      
                        {
                            Header: "Recording Year",
                            accessor: "recordingYear"
                        },
                        {
                            Header: "Language",
                            accessor: "lop"
                        },
                        {
                            Header: "Tags",
                            accessor: "tags",
                            Cell: row => <div><span title={row.value}>{row.value}</span></div>

                        },
                        {
                            Header: "Quality",
                            accessor: "quality"                       

                        },
                        {
                            Header: "Products",
                            accessor: "products"
                        },
                       

                    ]
                }
            ]}
            defaultSorted={[
                {
                    id: "name",
                    desc: true
                }
            ]}
            defaultPageSize={50}
            style={{
                height: "600px" // This will force the table body to overflow and scroll, since there is not enough room
            }}
            className="-striped -highlight"
        />)
};





export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Utilities);



// WEBPACK FOOTER //
// ./src/components/Utilities.js